import { Button, DataSource, Label, Layout, Panel, Table } from "@mcleod/components";

export abstract class AutogenLayoutClientAdmin extends Layout {
	buttonCloseClient: Button;
	labelPageTitle: Label;
	panelMain: Panel;
	sourceClientAdmin: DataSource;
	tableClientAdmin: Table;
}
